/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Link, url } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/agreementcopy/agreementcopy_styles';



/* ========== ~~~~~~~~~~ CTA : SIGN IN ~~~~~~~~~~ ========== */
const AgreementCopy = (props) => {
    return (
        <div className={`agreementcopy ${props.classes.agreementcopy}`}>
            <p>
                By clicking on ‘{props.clickDescription}’, you agree to the <Link action={`${url.company}/terms`} type={'external'} text={'Insticator Terms & Conditions'}/> and that you have read our <Link action={`${url.company}/privacy`} type={'external'} text={'Privacy Policy'}/>.
            </p>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AgreementCopy);
